import {
  GET_WEBSITE_START,
  GET_WEBSITE_SUCCESS,
  GET_WEBSITE_FAIL,
  GET_WEBSITES_START,
  GET_WEBSITES_SUCCESS,
  GET_WEBSITES_FAIL,
  SET_DEALER,
} from '../constants';

export const initialState = {
  website: null,
  websites: null,
  dealer: null,
  fetching: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_WEBSITES_START:
      return {
        ...state,
        fetching: true,
      };
    case GET_WEBSITES_SUCCESS:
      return {
        ...state,
        fetching: false,
        websites: action.payload,
      };
    case GET_WEBSITES_FAIL:
      return {
        ...state,
        fetching: false,
      };
    case GET_WEBSITE_START:
      return {
        ...state,
        fetching: true,
      };
    case GET_WEBSITE_SUCCESS:
      return {
        ...state,
        fetching: false,
        website: action.payload,
      };
    case GET_WEBSITE_FAIL:
      console.log('FAIL ACTION', action);
      return {
        ...state,
        fetching: false,
      };
    case SET_DEALER:
      return {
        ...state,
        dealer: action.payload,
      };
    default:
      return state;
  }
};
